import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=191e2758&scoped=true&"
import script from "./instructions.vue?vue&type=script&lang=js&"
export * from "./instructions.vue?vue&type=script&lang=js&"
import style0 from "./instructions.vue?vue&type=style&index=0&id=191e2758&lang=less&scoped=true&"
import style1 from "./instructions.vue?vue&type=style&index=1&id=191e2758&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e2758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191e2758')) {
      api.createRecord('191e2758', component.options)
    } else {
      api.reload('191e2758', component.options)
    }
    module.hot.accept("./instructions.vue?vue&type=template&id=191e2758&scoped=true&", function () {
      api.rerender('191e2758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/instructions.vue"
export default component.exports